import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { SystemReducer } from 'app/reducers/SystemReducer';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../SystemScreenStyles';
import * as SystemActions from "app/actions/SystemActions";
import { employeeById } from 'app/reducers';

const FilterScreen = (props) => {
    const classes = useStyles();
    const [names, setNames] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [keyuser, setKeyuser] = useState([]);
    const [functional, setfunctional] = useState([]);
    const dispatch = useDispatch();
    const {siteId} = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    const {
        isLoadingNames,
        listNames,
        isLoadingKeyUser,
        listKeyUser,
        isLoadingFunctional,
        listFunctional,
        filter,
        pagination, 
        isLoadExport
    } = useSelector(state => state.SystemReducer);

   const data = {
            subdirectionorigin: employeeData.idSubdirection,
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listName: props.FiltroSistemas.join(','),
            listKeyUser: props.FiltroKeyUser.join(','),
            listFunctional: props.FiltroFuncional.join(',')
   }
   
   
    const onSelectNames = (names) => {
        props.setFiltroSistemas(names);
    }

    const onSelectKeyUser = (keyuser) => {
        props.setFiltroKeyUser(keyuser);
    }

    const onSelectFunctional = (functional) => {
        props.setFiltroFuncional(functional);
    }

    

    const search = () => {
        dispatch(SystemActions.fetchSystems(data))
    }

    const exportXls = () => {
        dispatch(SystemActions.exportXls(data))
    }

    const optionName = listNames.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionKeyuser = listKeyUser.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    const optionFunctional = listFunctional.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    return (
        <div>
            <div hidden={collapse}>
            <Grid container direction="row" spacing={2}>
                <Grid item xs={6} >
                    <TextEvents
                        text='Sistemas:'
                        color="darker"
                        size='label'
                        weight="medium"
                    />
                    <Select
                        loading={isLoadingNames}
                        placeholder="[Selecionar Nombre]"
                        showSearch
                        value={props.FiltroSistemas}
                        onChange={onSelectNames}
                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                        optionFilterProp="Children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                    >
                        {optionName}
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text='KeyUser:'
                        color="darker"
                        size='label'
                        weight="medium"
                    />
                    <Select
                        loading={isLoadingKeyUser}
                        placeholder="[Selecionar KeyUser]"
                        showSearch
                        value={props.FiltroKeyUser}
                        onChange={onSelectKeyUser}
                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                        optionFilterProp="Children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                    >
                        {optionKeyuser}
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text='Funcional:'
                        color="darker"
                        size='label'
                        weight="medium"
                    />
                    <Select
                        loading={isLoadingFunctional}
                        placeholder="[Selecionar funcional]"
                        showSearch
                        value={props.FiltroFuncional}
                        onChange={onSelectFunctional}
                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                        optionFilterProp="Children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                    >
                        {optionFunctional}
                    </Select>
                </Grid>
            </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                  collapse ?
                    <Tooltip title={"Mostrar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(false)}
                      >
                        <Icon type="down" />
                      </Button>
                    </Tooltip> :
                    <Tooltip title={"Ocultar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(true)}
                      >
                        <Icon type="up" />
                      </Button>
                    </Tooltip>
                }

                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    loading={isLoadExport}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
                {
                    siteId === "HUB"?
                    <Button
                        className={classes.button}
                        variant="contained"
                        type="primary"
                        onClick={props.newSystem}
                    >
                        Nuevo
                    </Button>:null
                }
            </div>
        </div>
    );
}

export default FilterScreen;
